module.exports = __webpack_public_path__ + "img/geofisica_3-4_2304.b18f0ff6.jpg";